import React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Input } from '@ezetech/swag-space-x';
import { ReactComponent as CopyIcon } from 'assets/svg/copy-icon-small.svg?react';
import { SpaceStyledContentPopup } from 'swag-client-common/components/popups/space-styles-content-popup';
import classes from './create-reseller-prebuild-cart-popup.scss';
export const CreateResellerCartPopupComponent = props => {
  const {
    open,
    userEmail,
    cartLink,
    onConfirmClick,
    onCloseClick,
    notifyAboutCopy
  } = props;
  const Content = () => /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Input, {
    value: cartLink,
    disabled: true,
    adornmentEnd: /*#__PURE__*/React.createElement(CopyToClipboard, {
      onCopy: notifyAboutCopy,
      text: cartLink
    }, /*#__PURE__*/React.createElement(CopyIcon, {
      fill: "#8F39FF",
      className: classes.copyIcon
    }))
  }));
  return /*#__PURE__*/React.createElement(SpaceStyledContentPopup, {
    open: open,
    title: `Your Cart URL Link for ${userEmail}`,
    onConfirmClick: onConfirmClick,
    onCloseClick: onCloseClick,
    content: /*#__PURE__*/React.createElement(Content, null),
    continueBtnText: "Done",
    cancelBtnText: "Continue Editing"
  });
};